export const useFilterState = () => {
  return useState<Boolean>('filter', () => false)
}

export default function useFilter() {
  const filter = useFilterState()

  const show = () => {
    filter.value = true
  }

  const hide = () => {
    filter.value = false
  }

  return {
    filter,
    show,
    hide,
  }
}
